import { createFileRoute } from "@tanstack/react-router";
import { BviTool } from "@/components/Compliance/Bvi";

export const Route = createFileRoute("/_authenticated/compliance/bvi/")({
  component: BviTool,
  staticData: { page: "compliance" },
});
